module.exports = __webpack_public_path__ + "static/media/moment05.cdcd2f8c.webp";